// Beneficiary Report
export var EExportActionType;
(function (EExportActionType) {
    EExportActionType["Create"] = "CREATE";
    EExportActionType["CreateAndEmail"] = "CREATE_AND_EMAIL";
})(EExportActionType || (EExportActionType = {}));
// Revenues
export var ERevenuesPaymentStatus;
(function (ERevenuesPaymentStatus) {
    ERevenuesPaymentStatus["Unpaid"] = "UNPAID";
    ERevenuesPaymentStatus["Pending"] = "PENDING_AT_RENTIO";
    ERevenuesPaymentStatus["Paid"] = "PAID";
})(ERevenuesPaymentStatus || (ERevenuesPaymentStatus = {}));
export var ERevenuesInvoicedStatus;
(function (ERevenuesInvoicedStatus) {
    ERevenuesInvoicedStatus["Invoiced"] = "INVOICED";
    ERevenuesInvoicedStatus["NotInvoiced"] = "NOT_INVOICED";
})(ERevenuesInvoicedStatus || (ERevenuesInvoicedStatus = {}));
// Entity
export var EExportFileType;
(function (EExportFileType) {
    EExportFileType["Csv"] = "CSV";
    EExportFileType["Pdf"] = "PDF";
    EExportFileType["Xlsx"] = "XLSX";
})(EExportFileType || (EExportFileType = {}));
export var EExportType;
(function (EExportType) {
    EExportType["Activity"] = "ACTIVITY";
    EExportType["BeneficiaryReport"] = "BENEFICIARY_REPORT";
    EExportType["Contact"] = "CONTACT";
    EExportType["JackContractChecklist"] = "JACK_CONTRACT_CHECKLIST";
    EExportType["JackIndexationHistory"] = "JACK_INDEXATION_HISTORY";
    EExportType["JackPaymentRequests"] = "JACK_PAYMENT_REQUESTS";
    EExportType["JackPropertyContractTenant"] = "JACK_PROPERTY_CONTRACT_TENANT";
    EExportType["Properties"] = "PROPERTIES";
    EExportType["Revenues"] = "REVENUES";
})(EExportType || (EExportType = {}));
export var EExportStatus;
(function (EExportStatus) {
    // A custom export waiting its turn in the queue
    EExportStatus["Queued"] = "QUEUED";
    EExportStatus["New"] = "NEW";
    EExportStatus["Generated"] = "GENERATED";
    EExportStatus["Failed"] = "FAILED";
})(EExportStatus || (EExportStatus = {}));
// The exports the office picks on the export screen: queued and can be scheduled. They need the
// CUSTOM_EXPORTS office feature (CUSTOM_EXPORT_TYPES in rentio-api-next's exportFile.types.ts).
export var CUSTOM_EXPORT_TYPES = [
    EExportType.Properties,
    EExportType.JackPropertyContractTenant,
    EExportType.JackPaymentRequests,
    EExportType.JackContractChecklist,
    EExportType.JackIndexationHistory,
];
// The reports built for Jack. In production only the offices in JACK_EXPORT_BROKER_IDS see them;
// on the other environments every office does, so they can be tested.
export var JACK_EXPORT_TYPES = [
    EExportType.JackPropertyContractTenant,
    EExportType.JackPaymentRequests,
    EExportType.JackContractChecklist,
    EExportType.JackIndexationHistory,
];
// Production ids: Jack, and the Rentio Test Broker so we can try them in production.
export var JACK_EXPORT_BROKER_IDS = [473, 216];
export var CUSTOM_EXPORT_FILE_TYPES = [
    EExportFileType.Xlsx,
    EExportFileType.Csv,
];
